(function () {
  const banners = document.querySelectorAll('.banner-link[data-banner-id]');
  if (!banners.length || !window.Shopify?.analytics) return;

  const sentImpressions = new Set();          // banner_id を記録して重複発火防止

  // --- 1) Impression 共通 Observer（要素が 50 % 以上表示されたら）
  const io = new IntersectionObserver(entries => {
    entries.forEach(en => {
      if (!en.isIntersecting || en.intersectionRatio < 0.5) return;

      const el = en.target;
      const id = el.dataset.bannerId;
      if (sentImpressions.has(id)) return;    // 同一 ID の再送信を防ぐ
      sentImpressions.add(id);

      Shopify.analytics.publish('banner_impression', {
        banner_id: id,
        banner_name: el.dataset.bannerName,
        banner_position: el.dataset.bannerPosition,
        location: window.location.pathname
      });                                     // :contentReference[oaicite:1]{index=1}
    });
  }, { threshold: 0.5 });

  // --- 2) 各バナーに Observer & Click
  banners.forEach(el => {
    io.observe(el);

    el.addEventListener('click', () => {
      Shopify.analytics.publish('banner_clicked', {
        banner_id: el.dataset.bannerId,
        banner_name: el.dataset.bannerName,
        banner_position: el.dataset.bannerPosition,
        location: window.location.pathname
      });                                   // :contentReference[oaicite:2]{index=2}
    });
  });
})();